import PropTypes from 'prop-types';

/**
 * @memberof module:react/propTypes
 * @typedef {Object} OrderItem
 * @prop {number} id Order item id
 * @prop {string} fileStatus Order item file status
 * @prop {string} title Order item title
 * @prop {string} description Order item description
 */
export default PropTypes.shape({
  id: PropTypes.number,
  fileStatus: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string
});



// WEBPACK FOOTER //
// ./app/propTypes/axisOrderItem.js